export default class DateTimeHelper {

    public static toUTCDate(date: Date) : Date {
        if (!date || (date instanceof Date) === false) {
            return date;
        }
        return new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()))
    }
}